
























































import { Vue, Component } from 'vue-property-decorator'
import store from 'src/assets/store'
import MeUpdate from 'src/graphql/person/MeUpdate.gql'
import api from 'src/assets/api/gql'
import { PersonMenu } from 'src/graphql/types'

@Component
export default class PageIndex extends Vue {
  PersonMenu = PersonMenu
  me = store.state.person
  profileMenu: PersonMenu | null = null
  name = ''
  loading = false

  get isNameValid () {
    return !!this.name.trim()
  }

  created () {
    if (this.me.profileMenu && this.me.name.trim()) {
      this.$router.replace(this.me.profileMenu === 'PRESENTER' ? '/presenter/' : '/attendee/')
    }
  }

  setProfileMenu (profileMenu: PersonMenu) {
    this.profileMenu = profileMenu
    if (this.me.name.trim()) {
      this.save()
    }
  }

  async save () {
    this.loading = true
    const { data: { updatePerson } } = await api.mutate({
      query: MeUpdate,
      variables: {
        id: store.state.person.id,
        data: {
          name: this.name || this.me.name,
          profileMenu: this.profileMenu || this.me.profileMenu,
          locale: this.$i18n.locale || this.me.locale
        }
      }
    })
    this.loading = false
    if (updatePerson && updatePerson.person) {
      store.setPerson(updatePerson.person)
      if (this.profileMenu === PersonMenu.Attendee) {
        this.$router.replace('/attendee/')
      } else {
        this.$router.replace('/presenter/')
      }
    }
  }
}
